// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2GbZe","label":"Section_label__1wZxg","contentWrap":"Section_contentWrap__2S5xi","footer":"Section_footer__11hzz","footerInner":"Section_footerInner__2xQF-"};